import { Injectable, OnInit } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { JobsService } from '../services/jobs.service';
import { NotifyService } from '../services/notify.service';
import { ToastrService } from '../services/toastr.service';

@Injectable()
export class StateGuard implements CanActivate, OnInit {
    constructor(public router: Router, private jobsService: JobsService, private notifyService: NotifyService,
        private translateService: TranslateService, private toastService: ToastrService) {

    }

    ngOnInit() {
    }

    canActivate(route: ActivatedRouteSnapshot) {
        this.toastService.add({ severity: "info", summary: this.translateService.instant("TOAST.GENERAL.INFO_LOADING_TITLE"), detail: this.translateService.instant("TOAST.GENERAL.INFO_LOADING_DETAIL"), life: 20000});
        return new Observable<boolean>((observer) => {
            this.jobsService.getJobById(_.get(route.parent.paramMap, 'params.workId'), true).subscribe(work => {
                let obj = work;
                this.notifyService.notify({ key: "initialLoad", data: work });
                let state = _.get(obj, route.data['statePath']);
                let match = _.some(route.data['stateTarget'], s => _.isEqual(state, s));
                if (!match) {
                    this.router.navigate(['/pages']);
                }
                observer.next(match);
                this.toastService.clear()
            },
                (err) => {
                    this.notifyService.notify({ key: "initialLoad", data: null });
                    observer.next(true);
                })
        })

    }
}
